<template>
    <section class="work-item">
        <div class="row">
            <div class="col grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h4 v-if="$attrs.mode === 'new'">{{ $t('createNewTitle') }}</h4>
                        <h4 v-else class="card-title">
                            {{ $t('editEntry') }} <strong>{{ workItemName }}</strong> <code>(id {{ workItem.id }})</code>
                        </h4>
                        <p class="card-description pb-4">{{ $t('fillFieldsBelow') }}</p>

                        <div class="forms-sample">
                            <b-form-group :label="$t('forms.title')" label-for="title-input">
                                <b-form-input
                                    type="text"
                                    id="title-input"
                                    :placeholder="$t('forms.title')"
                                    v-model="workItem.title"
                                    :state="titleState"
                                />
                            </b-form-group>

                            <b-form-group label="Title EN" label-for="title-en-input">
                                <b-form-input
                                    type="text"
                                    id="title-en-input"
                                    placeholder="Title EN"
                                    v-model="workItem.titleEn"
                                    :state="titleEnState"
                                />
                            </b-form-group>

                            <b-form-group :label="$t('forms.city')" label-for="city-input">
                                <b-form-input
                                    type="text"
                                    id="city-input"
                                    :placeholder="$t('forms.city')"
                                    v-model="workItem.city"
                                    :state="cityState"
                                />
                            </b-form-group>

                            <b-form-group label="URL" label-for="url-input">
                                <b-form-input
                                    type="text"
                                    id="url-input"
                                    placeholder="URL"
                                    v-model="workItem.url"
                                    :state="urlState"
                                />
                            </b-form-group>

                            <b-form-group :label="$t('forms.order')" label-for="order-input">
                                <b-form-input
                                    type="number"
                                    id="order-input"
                                    :placeholder="$t('forms.order')"
                                    v-model="workItem.displayOrder"
                                    :state="orderState"
                                />
                            </b-form-group>

                            <b-button variant="success" class="mr-2" @click="saveItem" :disabled="validated">
                                {{ $t('forms.save') }}
                            </b-button>
                            <b-button variant="light" v-on:click="cancel">{{ $t('forms.cancel') }}</b-button>
                            <b-button
                                v-if="$attrs.mode === 'edit'"
                                variant="danger"
                                class="float-right"
                                v-b-modal.confirm-delete
                            >
                                {{ $t('forms.delete') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            id="confirm-delete"
            :title="$t('forms.warning')"
            size="md"
            header-bg-variant="danger"
            header-text-variant="light"
            :cancelTitle="$t('forms.cancel')"
            :okTitle="$t('forms.delete')"
            @ok="deleteItem"
        >
            <p class="text-center">{{ $t('forms.deleteConfirmationMessage') }}</p>
        </b-modal>
    </section>
</template>

<script>
import axios from 'axios'
import { Const } from '../../../main'

export default {
    name: 'WorkItem',
    computed: {
        titleState() {
            return !!(this.workItem.title && this.workItem.title.length > 0)
        },
        titleEnState() {
            return !!(this.workItem.titleEn && this.workItem.titleEn.length > 0)
        },
        cityState() {
            return !!(this.workItem.city && this.workItem.city.length > 0)
        },
        urlState() {
            return !!(this.workItem.url && this.workItem.url.length > 0)
        },
        orderState() {
            return !!(this.workItem.displayOrder && this.workItem.displayOrder > 0)
        },
        validated() {
            return !this.titleState || !this.titleEnState || !this.cityState || !this.urlState || !this.orderState
        }
    },
    data() {
        return {
            workItem: {},
            workItemName: ''
        }
    },
    mounted() {
        if (this.$attrs.mode === Const.MODE_EDIT) {
            axios.get(Const.API_HOST + '/admin/workItem/get', {
                params: {
                    id: this.$route.params.id
                }
            }).then(function (response) {
                return response.data
            }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error)
            }).then(body => {
                this.workItem = body
                this.workItemName = JSON.parse(JSON.stringify(this.workItem.title))
            })
        } else {
            this.workItem = {
                id: '',
                title: '',
                titleEn: '',
                city: '',
                url: '',
                displayOrder: ''
            }
        }
    },
    methods: {
        cancel() {
            this.$router.push('/work-items')
        },
        saveItem() {
            var app = this
            axios.post(Const.API_HOST + '/admin/workItem/save', {
                id: this.workItem.id,
                title: this.workItem.title,
                titleEn: this.workItem.titleEn,
                city: this.workItem.city,
                url: this.workItem.url,
                displayOrder: this.workItem.displayOrder
            }).then(function (response) {
                if (response.status === 200) {
                    app.$router.push('/work-items')
                }
            }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error)
            })
        },
        deleteItem() {
            var app = this
            axios.delete(Const.API_HOST + '/admin/workItem/delete', {
                data: {
                    id: this.workItem.id
                }
            }).then(function (response) {
                if (response.status === 200) {
                    app.$router.push('/work-items')
                }
            }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error)
            })
        }
    }
}
</script>

<style scoped>
.clickable /deep/ tbody td {
    cursor: pointer;
}
</style>
